export default "__VITE_ASSET__Bwdv43vl__"